import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SosService extends BaseService{
  private readonly apiUrl = environment.apiUrl;
  
  constructor(protected override http: HttpClient) {
    super(http);
  }
  startSosSession( audience: string ): void {
    const redirectUriMap: { [key: string]: string } = {
      [environment.fZAudience]: environment.sosUrl,
      [environment.gaadAudience]: environment.gaadUrl,
      [environment.eogaAudience]: environment.eogaUrl,
      [environment.eogaPortalSoft]: environment.eogaPortalSoftUrl,
    };
    const redirectUri = redirectUriMap[audience] ?? environment.gaadUrl;
    const payload = { audience: audience, redirectUri: redirectUri };
    this.getAuthSos(payload).subscribe((response: any) => {
      const authorizationUrl  = response?.data?.redirectUrl ?? response?.redirectUrl;
      console.log('Redirecting to SSO URL:', authorizationUrl);
      window.location.href = authorizationUrl;
    });
  }
   getAuthSos(payload: any): Observable<any> {
     return this.post<any>(`${this.apiUrl}/gafi-cpcr/sso/authorize`, payload);
   }
 
}
